<template>
  <Dialog :open="modal.isOpen" @update:open="modal.close">
    <DialogContent class="max-w-md z-[2000]" overlay-class="z-[2000]">
      <DialogHeader>
        <DialogTitle>{{ modal.title }}</DialogTitle>
      </DialogHeader>

      <p class="text-sm text-gray-700 dark:text-gray-300 mb-4">
        {{ modal.message }}
      </p>

      <DialogFooter class="flex justify-end gap-2">
        <Button variant="outline" @click="modal.cancel">
          {{ modal.cancelText }}
        </Button>

        <Button variant="default" @click="modal.confirm">
          {{ modal.confirmText }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { useModalStore } from "@/store/modules/modal"
import { closeAllModalsEventBus } from "@/utils/eventBus"
import Dialog from "@/components/ui/dialog/Dialog.vue";
import DialogContent from "@/components/ui/dialog/DialogContent.vue";
import DialogHeader from "@/components/ui/dialog/DialogHeader.vue";
import DialogTitle from "@/components/ui/dialog/DialogTitle.vue";
import DialogFooter from "@/components/ui/dialog/DialogFooter.vue";
import Button from "@/components/ui/button/Button.vue";

const modal = useModalStore()

closeAllModalsEventBus.on(() => {
  modal.close()
})
</script>